import * as Highcharts from 'highcharts';
import { TDualBarChartWidgetModelInputs } from '@monorepo/types';

export const DUAL_BAR_CHART_WIDGET_MODEL = {
  createModel: (input?: TDualBarChartWidgetModelInputs): Highcharts.Options => {
    if (!input) return {};

    // return {};

    return {
      chart: {
        type: 'column',
        backgroundColor: 'transparent',
      },
      title: {
        text: undefined,
      },
      xAxis: {
        categories: input.chartDataSets.labelDataSet,
        ...(input.config.xLabel.display
          ? {
              title: {
                text: input.config.xLabel.name,
              },
            }
          : {}),
        labels: {
          style: {
            color: '#ffffff',
            fontSize: '20px',
          },
        },
        // tickLength: 50,
        // tickmarkPlacement: 'between',
        // tickColor: 'green',
      },
      yAxis: {
        ...(input.config.yLabel.display
          ? {
              title: {
                text: input.config.yLabel.name,
              },
            }
          : {}),
        labels: {
          style: {
            color: '#ffffff',
            fontSize: '18px',
          },
        },
        gridLineColor: 'rgba(228, 228, 230, 0.5)',
        gridLineWidth: 1,
        // tickInterval: 10,
        // startOnTick: false,
        // tickPosition: 'inside',
        // tickmarkPlacement: 'between',
        // tickColor: 'green',
      },
      plotOptions: {
        line: {
          enableMouseTracking: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
        column: {
          enableMouseTracking: false,
          states: {
            hover: {
              enabled: false,
            },
          },

          pointPadding: 0,
          borderWidth: 0,
          borderRadius: 0,
          dataLabels: {
            style: {
              fontSize: '20',
              fontWeight: '800',
              color: 'white',
            },
            enabled: true,
            formatter: function () {
              return this.y?.toString().replace(/\s/g, ''); // Removes spaces
            },
          },
        },
      },
      series: [
        {
          type: 'column',
          name: input.config.barOne.name,
          data: input.chartDataSets.barOneDataSet,
          color: input.config.barOne.barColor,
          zIndex: 1,
        },
        {
          type: 'column',
          name: input.config.barTwo.name,
          data: input.chartDataSets.barTwoDataSet.map((value, index) => ({
            y: value,
            color: input.chartDataSets.barColorDataSet
              ? input.chartDataSets.barColorDataSet[index]
              : input.config.barTwo.barColor,
          })),
          zIndex: 1,
        },
        ...(input.chartDataSets.minWipDataSet
          ? [
              {
                type: 'line',
                name: 'Min WIP',
                data: input.chartDataSets.minWipDataSet,
                color: '#ffffff',
                marker: {
                  enabled: false,
                },
                dashStyle: 'ShortDash',
                zIndex: 0,
              } as Highcharts.SeriesLineOptions,
            ]
          : []),
        ...(input.chartDataSets.minWipDataSet
          ? [
              {
                type: 'line',
                name: 'Max WIP',
                data: input.chartDataSets.maxWipDataSet,
                color: '#ffffff',
                marker: {
                  enabled: false,
                },
                dashStyle: 'ShortDash',
                zIndex: 0,
              } as Highcharts.SeriesLineOptions,
            ]
          : []),
      ],
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
    };
  },
};
